import React from 'react';
import {
  Warehouse, ClipboardList, Package, PackageCheck, Truck, ArrowLeftRight,
  Box, Tag, Wrench, BarChart3,
  Lock, Cpu, Scaling, Layers
} from 'lucide-react';
import ServicePageTemplate from '../components/ServicePageTemplate';

const WarehousingPage = () => {
  return (
    <ServicePageTemplate
      heroTitle="Warehousing & Value-Added Services"
      heroImage="/img/warehouse.jpg"
      slug="warehousing"
      introText={[
        'Denver Logistics Private Limited offers secure, scalable, and technology-driven warehousing solutions designed to optimize inventory management and streamline supply chain operations.',
        'Our modern warehousing facilities and value-added services ensure efficient storage, order fulfillment, and timely distribution, helping businesses improve operational efficiency and reduce logistics costs.',
      ]}
      services={[
        'Secure Warehousing & Storage',
        'Inventory Management',
        'Pick & Pack Services',
        'Order Fulfillment',
        'Distribution & Last-Mile Delivery',
        'Cross Docking',
        'Packaging & Repackaging',
        'Labelling & Barcoding',
        'Kitting & Assembly',
        'Stock Monitoring & Reporting',
      ]}
      serviceIcons={[
        Warehouse, ClipboardList, Package, PackageCheck, Truck, ArrowLeftRight,
        Box, Tag, Wrench, BarChart3
      ]}
      benefits={[
        { title: 'Secure Facilities', description: 'Modern, secure warehousing facilities with 24/7 monitoring.' },
        { title: 'Technology-Driven', description: 'Advanced inventory management systems for real-time visibility.' },
        { title: 'Scalable Solutions', description: 'Flexible warehousing options that scale with your business needs.' },
        { title: 'Value-Added Services', description: 'Comprehensive services from pick & pack to last-mile delivery.' },
      ]}
      benefitIcons={[Lock, Cpu, Scaling, Layers]}
      callout={{
        eyebrow: 'EFFICIENT WAREHOUSING SOLUTIONS.',
        sub: 'Storage. Handling. Distribution.',
        ctaLabel: 'GET WAREHOUSING SOLUTIONS',
      }}
      faq={[
        { q: 'What types of goods can you store?', a: 'We handle a wide range of goods including general merchandise, electronics, automotive parts, FMCG, pharmaceuticals, and industrial equipment. Our facilities are designed to accommodate various storage requirements with appropriate handling procedures.' },
        { q: 'Do you offer inventory management systems?', a: 'Yes. We use advanced, technology-driven inventory management systems that provide real-time stock visibility, automated reporting, and accurate order fulfillment tracking. You can monitor your inventory levels at any time.' },
        { q: 'What value-added services do you provide?', a: 'Our value-added services include pick & pack, order fulfillment, kitting & assembly, labelling & barcoding, packaging & repackaging, quality inspection, and last-mile delivery coordination.' },
      ]}
    />
  );
};

export default WarehousingPage;
